import Enquiries from "./Enquiries.js";
export default Enquiries;
